/* @flow */

import * as React from 'react';

import {AccentBorder} from 'shells/accent-border';
import {Card} from 'shells/card';
import {RemoveButton} from 'shells/button';
import {colors} from 'shells/colors';
import {LoadingText} from 'shells/loading-placeholder/loading-text';

import './select-field.css';

type Props = {
    name: string,
    onRemove?: () => void,
    isLoading?: boolean,
    borderColor?: string,
    onClick?: () => void,
};

export function SelectedFieldCard(props: Props) {
    return (
        <div styleName='select-card'>
            <Card hasBorder={true} onClick={props.onClick}>
                <AccentBorder location='left' color={props.borderColor || colors.lead}>
                    <div styleName='input-container'>
                        {props.isLoading ? (
                            <LoadingText height={27} />
                        ) : (
                            <>
                                {props.name}
                                {props.onRemove ? (
                                    <RemoveButton
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            // $FlowIgnore checked above
                                            props.onRemove();
                                        }}
                                        size={12}
                                    />
                                ) : null}
                            </>
                        )}
                    </div>
                </AccentBorder>
            </Card>
        </div>
    );
}
